import { useSelector } from "react-redux";
import { selectors as contactsSelectors } from "modules/contacts";

export function useGetSelectedVendorFromProject(selectedVendorId = "") {
  const vendorList = useSelector(contactsSelectors.getVendorList);
  const currentSelectedVendor = vendorList.find(v => v.id === selectedVendorId);
  return currentSelectedVendor;
}
